/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondToAppraisalRequestOneOf
 */
export interface RespondToAppraisalRequestOneOf {
    /**
     * 
     * @type {string}
     * @memberof RespondToAppraisalRequestOneOf
     */
    outcome: RespondToAppraisalRequestOneOfOutcomeEnum;
    /**
     * 
     * @type {number}
     * @memberof RespondToAppraisalRequestOneOf
     */
    requestEventId: number;
    /**
     * 
     * @type {string}
     * @memberof RespondToAppraisalRequestOneOf
     */
    notes?: string;
}


/**
 * @export
 */
export const RespondToAppraisalRequestOneOfOutcomeEnum = {
    Accepted: 'accepted'
} as const;
export type RespondToAppraisalRequestOneOfOutcomeEnum = typeof RespondToAppraisalRequestOneOfOutcomeEnum[keyof typeof RespondToAppraisalRequestOneOfOutcomeEnum];


/**
 * Check if a given object implements the RespondToAppraisalRequestOneOf interface.
 */
export function instanceOfRespondToAppraisalRequestOneOf(value: object): value is RespondToAppraisalRequestOneOf {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    if (!('requestEventId' in value) || value['requestEventId'] === undefined) return false;
    return true;
}

export function RespondToAppraisalRequestOneOfFromJSON(json: any): RespondToAppraisalRequestOneOf {
    return RespondToAppraisalRequestOneOfFromJSONTyped(json, false);
}

export function RespondToAppraisalRequestOneOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondToAppraisalRequestOneOf {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'],
        'requestEventId': json['requestEventId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function RespondToAppraisalRequestOneOfToJSON(json: any): RespondToAppraisalRequestOneOf {
    return RespondToAppraisalRequestOneOfToJSONTyped(json, false);
}

export function RespondToAppraisalRequestOneOfToJSONTyped(value?: RespondToAppraisalRequestOneOf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'requestEventId': value['requestEventId'],
        'notes': value['notes'],
    };
}

